import { render, staticRenderFns } from "./dash_channels.vue?vue&type=template&id=1a56e396&scoped=true&"
import script from "./dash_channels.vue?vue&type=script&lang=js&"
export * from "./dash_channels.vue?vue&type=script&lang=js&"
import style0 from "./dash_channels.vue?vue&type=style&index=0&id=1a56e396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a56e396",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/nico/Projects/ecopbx-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable,VDivider,VFlex,VLayout})
